import { ReactNode } from 'react'

type AnimatedAccordionProps = {
  isExpanded: boolean
  children: ReactNode
  className?: string
  duration?: number
  easing?: string
}

export default function AnimatedAccordion({
  isExpanded,
  children,
  className = '',
  duration = 0.25,
  easing = 'cubic-bezier(0.4, 0, 0.2, 1)'
}: AnimatedAccordionProps) {
  return (
    <div
      className={`w-full ${className}`}
      style={{
        display: 'grid',
        gridTemplateRows: isExpanded ? '1fr' : '0fr',
        transition: `grid-template-rows ${duration}s ${easing}`
      }}
      aria-hidden={!isExpanded}
    >
      <div className={`overflow-hidden`}>
        <div className='pt-2'>{children}</div>
      </div>
    </div>
  )
}
